import $ from 'jquery';

class ContentSelector {
  constructor(component) {
    this.component = component;
    this.selector = $(this.component).find('[data-form-filter="content-selector"]');
    this.contents = $(this.component).find('[data-content-selector-contents]');

    if (this.selector.length === 0) {
      return;
    }

    this.selector.select2({
      templateResult: ContentSelector.formatOption,
      templateSelection: ContentSelector.formatOption,
    });
    this.selector.on('change', () => {
      this.changeContent(this.selector.val());
    });
    this.selector.on('select2:open', function(){
      $('.select2-search__field').attr('placeholder', 'Type to search');
    });

    this.showDefaultContent();
  }

  showDefaultContent() {
    this.hideAllContent();
    const defaultContent = window.location.hash.replace('#', '') || 'default';
    this.selector.val(defaultContent).trigger('change');
  }

  changeContent(id) {
    this.hideAllContent();
    this.getContent(id).show();
  }

  hideAllContent() {
    this.getAllContent().hide();
  }

  getContent(id) {
    return this.contents.find(`[data-content-selector-content=${id}]`);
  }

  getAllContent() {
    return this.contents.find('[data-content-selector-content]');
  }

  static formatOption(option) {
    const delimiter = ' – ';
    const text = option.text.split(delimiter);
    if (text.length === 2) {
      return $(`<span><strong>${text[0]}</strong>${delimiter}${text[1]}</span>`);
    }

    return option.text;
  }
}

export default function initialize() {
  const contentSelectors = $('[data-content-selector]');
  contentSelectors.each(function() {
    new ContentSelector(this);
  })
}


// WEBPACK FOOTER //
// ./scripts/lib/components/content-selector.js